import React from "react";
import { connect } from "react-redux";
import { findDOMNode } from "react-dom";
import { setFocus } from "../../actions/actions";
import Message from "../../components/app/Message";
import "../../assets/styles/messages.css";
import closeImg from "../../assets/images/icon-x-16.svg";
import exitTop from "../../assets/images/exit-top.svg";
import closeImgWhite from "../../assets/images/icon-x.svg";

class MessageBox extends React.Component {
  componentDidMount() {
    let messagebox = findDOMNode(this.refs.messagebox);
    messagebox.scrollIntoView();
    messagebox.focus();
    this.props.setFocus(null);
  }

  render() {
    let _closeImg = closeImg;
    let { text, onCancel, onOk, okText, cancelText, htmlText, topImg } =
      this.props;
    if (
      topImg === "" &&
      this.props.text.props.children[0].props.children === "רק מוודאים..."
    ) {
      topImg = exitTop;
      _closeImg = closeImgWhite;
    }
    okText = okText || "אישור";
    cancelText = cancelText || "ביטול";

    const getMsgText = () => {
      if (htmlText) {
        return (
          <div className="text-msg-wrap" ref="messagebox">
            {text}
          </div>
        );
      } else {
        return (
          <div className="message-info f5" ref="messagebox" tabIndex="-1">
            <Message message={text} />
          </div>
        );
      }
    };

    const getFooter = () => {
      if (!onOk && !onCancel) return null;

      let ok = null;
      if (onOk) {
        ok = (
          <button
            type="button"
            className="btn btn-ok bg-m color-n color-nl pointer"
            onClick={() => onOk()}
          >
            {okText}
          </button>
        );
      }

      let cancel = null;
      if (onCancel) {
        cancel = (
          <div className="btn-cancel-wrap">
            <button
              type="button"
              className="btn btn-cancel bg-j color-m f5 pointer"
              onClick={() => onCancel()}
            >
              {cancelText}
            </button>
          </div>
        );
      }

      return (
        <div className="message-btn-wrapper clearfix">
          {ok}
          {cancel}
        </div>
      );
    };

    if (!text) return null;

    return (
      <div className="message-wrapper" role="alertdialog">
        <div className="message-container bg-n bg-nl bg-grad">
          <div className="close-icon pointer">
            <img onClick={() => onCancel()} src={_closeImg} />
          </div>
          <div className="top-img-wrap">
            <img src={topImg} />
          </div>
          {getMsgText()}
          {getFooter()}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCancel: ownProps.onCancel,
    onOk: ownProps.onOk,
    setFocus: (refName) => {
      dispatch(setFocus(refName));
    },
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    text: ownProps.text,
    okText: ownProps.okText,
    cancelText: ownProps.cancelText,
    focusOn: state.session.app.focusOn,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageBox);



// WEBPACK FOOTER //
// ./src/containers/app/MessageBox.jsx